import * as t from 'io-ts';

import {makeApiType, makeEnumRuntimeType, RExternalChannelTypeIdRef} from './apiTypes';

/*
 * Runtime type.
 */

export enum ExternalChannelTypeAuthorizationTypesEnum {
  API_KEY = 'api_key',
  OAUTH = 'oauth',
}

const RExternalChannelTypeDirty = t.readonly(
  t.intersection([
    t.type({
      id: t.Integer,
      name: t.string,
      description: t.string,
      status: t.string,
      updatedAt: t.Integer,
      authorizationType: makeEnumRuntimeType(ExternalChannelTypeAuthorizationTypesEnum),
    }),
    t.partial({
      iconUrl: t.string,
    }),
  ]),
);

/*
 * Type.
 */

export interface ExternalChannelTypeModel extends t.TypeOf<typeof RExternalChannelTypeDirty> {}
export const RExternalChannelType = t.clean<ExternalChannelTypeModel>(RExternalChannelTypeDirty as any);
export const RExternalChannelTypes = t.readonlyArray(RExternalChannelType);
RExternalChannelTypeIdRef.setTargetType(RExternalChannelType);

/*
 * IO methods.
 */

export function parseExternalChannelType(src: any): ExternalChannelTypeModel {
  return {
    id: src.id,
    name: src.name,
    description: src.description,
    iconUrl: src.icon_url || undefined,
    status: src.status,
    // TODO: Expose updated_at on the endpoint to properly support this.
    updatedAt: 0,
    authorizationType: src.authorization_type,
  };
}

export function parseExternalChannelTypes(src: any) {
  return src.external_channel_types && src.external_channel_types.map(parseExternalChannelType);
}

/*
 * API type.
 */

export const ApiExternalChannelType = makeApiType(
  'externalChannelType',
  RExternalChannelType,
  parseExternalChannelType,
);
export const ApiExternalChannelTypes = makeApiType(
  'externalChannelTypes',
  RExternalChannelTypes,
  parseExternalChannelTypes,
);
